import { PlusOutlined } from '@ant-design/icons';
import {
    Button,
    Modal as MuiModal,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow
} from '@mui/material';
import { Button as AntButton, Modal as AntModal, Card, Col, Divider, Input, Row, Tabs } from 'antd';
import PasswordRevealInline from 'components/PasswordRevealInline';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import sortBy from 'lodash/sortBy';
import moment from 'moment';
import React, { useCallback , useMemo, useState , useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useCurrentOrg } from 'store/organizations/selectors';
import { handleEnableDiableUser } from 'store/users/thunks';

import VocabAccessModal from 'components/admin/VocabPermission';
import Loading from 'components/Loading';
import Login_as from 'features/forms/admin/Login_as';
import COLOR from 'utils/constants/color';
import { handleGetTeacherForOrg , handleSearchUserForOrg } from 'store/organizations/thunks';
import SpinLoader from 'components/Loader/SpinLoader';
import { getUserIntegrationDetail } from 'utils/methods/textMethod';
import usePermissionForUser from 'components/hooks/permissions/usePermissionForUser';
import { openAutologin } from 'store/keystore/thunks';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';


const BORDERCOLOR = [
  'rgb(200,109,152)',
  'rgb(146,158,227)',
  'rgb(80,233,200)',
  'rgb(238,206,151)'
];

const Wrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const SectionTitle = styled.p`
  color: black;
  font-size: 17px;
  font-weight: 400;
`;

const Highlight = styled.span`
  font-weight: 600;
`;

const ViewDemo = styled.span`
  margin-left: 4px;
  color: ${({ color }) => color};
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${COLOR.white};
  border-radius: 3px;
  padding: 16px;
  text-align: center;
`;

const ModalActions = styled(Row)`
  margin-top: 16px;
  justify-content: center;
`;
const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const BarsLoader = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
  height: 10px;
  gap: 3px;

  span {
    width: 4px;
    background: #722ed1;
    animation: barAnim 0.8s infinite;
  }

  span:nth-child(1) { animation-delay: 0s; }
  span:nth-child(2) { animation-delay: 0.1s; }
  span:nth-child(3) { animation-delay: 0.2s; }

  @keyframes barAnim {
    0%, 100% { height: 6px; opacity: 0.3; }
    50% { height: 12px; opacity: 1; }
  }
`;
export default function TeacherTable({
  userloading,
  onTabsJump = () => {},
  active_tab
}) {
  const {isUserCoach} = usePermissionForUser();
  const showAlert = useAlert();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const org = useCurrentOrg();
  const [pageInfo, setPageInfo] = useState({ page: 0, rowsPerPage: 100 });
  const [demopageInfo, setdemoPageInfo] = useState({ page: 0, rowsPerPage: 100 });
  const [activeTab, setActiveTab] = useState('1');
  const [searchText, setSearchText] = useState('');
  const [detailOpen, setDetailOpen] = useState(false);
  const [confirmUser, setConfirmUser] = useState(null);
  const [teacherData, setTeacherData] = useState(null);
  const [enableLoadingId, setEnableLoadingId] = useState(null);
  const [data_loading, setDataLoading] = useState(false);
  const [total_count, setToatalCount] = useState(0);
  const [allTeachers,setAllTeachers] = useState([]) 
  const [total_count_demo, setToatalCountDemo] = useState(0);
  const [allTeacherDemo, setAllTeacherDemo] = useState([]) 
  const [searchResults, setSearchResults] = useState([]);
  const [demoSearchResults, setDemoSearchResults] = useState([]);
  const [searchLoader, setSearchLoader] = useState(false);
  const [autologinLoader, setAutologinLoader] = useState(false);
  const prevOrgIdRef = useRef(org?.id);

  async function seachTeacher() {
    try {
      setSearchLoader(true);
      const response = await dispatch(
          handleSearchUserForOrg(0, 100, org.id, false, searchText, 'teacher') // false = not demo
        );
        if (response?.success) {
          setSearchResults(response.data?.users || []);
          setToatalCount(response.data?.total_count || 0);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setSearchLoader(false);
      }
    }
  
    async function seachDemoTeacher() {
      try {
        setSearchLoader(true);
        const response = await dispatch(
          handleSearchUserForOrg(0,100,org.id,true, searchText,'teacher') // true = demo
        );
        if (response?.success) {
          setDemoSearchResults(response.data?.users || []);
          setToatalCountDemo(response.data?.total_count || 0);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setSearchLoader(false);
      }
    }
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (active_tab !== "see_teachers") return;
      if (!org?.id) return;

      if (searchText) {
        if (activeTab === '1') {
          seachTeacher();
        } else {
          seachDemoTeacher();
        }
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchText, org, activeTab]);
  const onSearchBlank = useCallback((e) => {
    if (activeTab === '1') {
      getTeacherInfo();
    } else {
      getDemoTeacherInfo();
    }
  }, [activeTab, org]);
  async function getTeacherInfo() {
    try {
      setDataLoading(true)
      const response = await dispatch(handleGetTeacherForOrg(pageInfo.page*pageInfo.rowsPerPage,pageInfo.rowsPerPage,org.id))
      if (response && response.success) {
        const { total_count, teachers: teachersResult } = response.data || {};
        setToatalCount(total_count)
        setAllTeachers(teachersResult)
      }
    } catch (error) {
      console.error('getTeacherInfo error:', error);
    } finally {
      setDataLoading(false)
    }

  }
  async function getDemoTeacherInfo() {
    try {
      setDataLoading(true)
      const response = await dispatch(handleGetTeacherForOrg(demopageInfo.page*demopageInfo.rowsPerPage,demopageInfo.rowsPerPage,org.id,true))
      if (response && response.success) {
        const { total_count, teachers: teachersResult } = response.data || {};
        setToatalCountDemo(total_count)
        setAllTeacherDemo(teachersResult)
      }
    } catch (error) {

    } finally {
      setDataLoading(false)
    }

  }
  useEffect(() => {
    if (org && org.id) {
      if (active_tab != "see_teachers") return;
      if (activeTab == 1) {
        getTeacherInfo()
      }
    }
  }, [org, pageInfo, active_tab, activeTab])
  useEffect(() => {
    if (org && org.id) {
      if (active_tab != "see_teachers") return;
      if (activeTab == '2') {
        getDemoTeacherInfo()
      }
    }
  }, [org, demopageInfo, active_tab, activeTab])

  useEffect(() => {
    if (active_tab !== "see_teachers") return;
    if (prevOrgIdRef.current !== undefined && prevOrgIdRef.current !== org?.id) {
      setSearchText('');
      setSearchResults([]);
      setDemoSearchResults([]);
    }
    prevOrgIdRef.current = org?.id;
  }, [org?.id, active_tab])

  const getName = (u, key, alt) => String((u?.[key] ?? u?.[alt]) ?? '').trim();

  // apply selectedDist filter
  const baseList = useMemo(() => {
    const list = activeTab == '1' ? allTeachers : allTeacherDemo;
    return sortBy(list || [], [
      (u) => getName(u, 'firstName', 'first_name').toLowerCase(),
      (u) => getName(u, 'lastName', 'last_name').toLowerCase()
    ]);
  }, [allTeachers, allTeacherDemo, activeTab]);

  // apply search
  const filtered = useMemo(() => {
    if (!searchText) return baseList;
    const search_list = activeTab === '1' ? searchResults : demoSearchResults;
    // if (isEmpty(search_list)) return baseList;
    return sortBy(search_list || [], [
      (u) => getName(u, 'firstName', 'first_name').toLowerCase(),
      (u) => getName(u, 'lastName', 'last_name').toLowerCase()
    ]);
  }, [baseList, searchText , searchResults , demoSearchResults, activeTab ]);


  // pagination slice
  const pageRows = useMemo(() => {
    return filtered;
  }, [filtered, pageInfo]);

  // handlers
  const onSearch = useCallback((e) => {
    if (e.target.value.trim() === '') {
      onSearchBlank(e);
    }
    setSearchText(e.target.value);
  }, []);

  const onPageChange = useCallback((_, newPage) => {
    setPageInfo((p) => ({ ...p, page: newPage }));
  }, []);

  const onRowsPerPageChange = useCallback((e) => {
    setPageInfo({ page: 0, rowsPerPage: +e.target.value });
  }, []);
  const onDemoPageChange = useCallback((_, newPage) => {
    setdemoPageInfo((p) => ({ ...p, page: newPage }));
  }, []);

  const onDemoRowsPerPageChange = useCallback((e) => {
    setdemoPageInfo({ page: 0, rowsPerPage: +e.target.value });
  }, []);

  // open detail modal
  const openDetail = useCallback(
    (u) => {
      const createdAt = get(u, 'createdAt', '');
      const formatted = createdAt
        ? moment(parseInt(createdAt)).format('YYYY-MM-DD HH:mm:ss')
        : '';
      setTeacherData({ ...u, date: formatted });
      setDetailOpen(true);
    },
    []
  );

  const handleOpenAutologin = async (schoologyid) => {
    setAutologinLoader(true);
    try {
      const result = await openAutologin(schoologyid);
      if (result && !result.success) {
        showAlert(result.message || 'Autologin URL not found', 'error');
      }
    } catch (error) {
      showAlert('Error fetching autologin URL. Please try again.', 'error');
    } finally {
      setAutologinLoader(false);
    }
  };
  const closeDetail = useCallback(() => setDetailOpen(false), []);

  // confirm enable/disable
  const openConfirm = useCallback((u) => setConfirmUser(u), []);
  const closeConfirm = useCallback(() => setConfirmUser(null), []);

  const handleToggleActive = useCallback(async () => {
    if (!confirmUser) return;
    setEnableLoadingId(confirmUser.id);
    const response = await dispatch(
      handleEnableDiableUser(confirmUser.id, !confirmUser.active)
    );
    setEnableLoadingId(null);
    if(response){
      setAllTeachers((prev) => {
        return prev?.map((element) => {
          if (element.id === response.id) {
            return { ...element, active: !confirmUser.active };
          } else {
            return element;
          }
        });
      });

      if (searchText?.length > 0) {
        setSearchResults((prev) =>
          prev?.map((element) => {
            if (element.id === response.id) {
              return { ...element, active: !confirmUser.active };
            } else {
              return element;
            }
          }),
        );
        setDemoSearchResults((prev) =>
          prev?.map((element) => {
            if (element.id === response.id) {
              return { ...element, active: !confirmUser.active };
            } else {
              return element;
            }
          }),
        );
      }
    }
    closeConfirm();
  }, [dispatch, confirmUser, closeConfirm]);


  // navigation to edit/add teacher
  const onAddTeacher = useCallback(
    (isEdit = false) =>
      navigate('/add-users', {
        state: { userData: isEdit ? teacherData : { role:"teacher" }, isEdit }
      }),
    [navigate, teacherData]
  );

  // table columns
  const columns = [
    {
      label: 'School Name',
      render: (u) => {

        return (
          <>
            {get(u, 'school_name', '')}
          </>
        );
      }
    },
    { label: 'First Name', render: (u) => getName(u, 'firstName', 'first_name') },
    { label: 'Last Name', render: (u) => getName(u, 'lastName', 'last_name') },
    {
      label: 'Classes',
      render: (u) => {
        return (
          <span
            style={{ color: BORDERCOLOR[0], cursor: 'pointer' }}
            onClick={() => onTabsJump('see_classes', u)}
          >
            {u.active_class_count||0}
          </span>
        );
      }
    },
    {
      label: 'Status',
      render: (u) => (
        <Button
          variant="contained"
          color={u.active ? 'primary' : 'secondary'}
          sx={{ fontSize: 12, width: 80 }}
          onClick={(e) => {
            e.stopPropagation();
            openConfirm(u);
          }}
          disabled={isUserCoach}
        >
          {enableLoadingId === u.id ? (
            <Loading size={18} white />
          ) : u.active ? (
            'Enabled'
          ) : (
            'Disabled'
          )}
        </Button>
      )
    }
  ];

  // build the two tabs
  const tabs = [
    {
      key: '1',
      label: 'Teachers',
      children: (
        <TableContainer sx={{ backgroundColor: '#fff' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {columns.map((col, i) => (
                  <TableCell
                    key={i}
                    sx={{ fontSize: 16, fontWeight: 600, textAlign: 'left' }}
                  >
                    {col.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {isEmpty(pageRows) ? (
                userloading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <Loading size={30} />
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      No results
                    </TableCell>
                  </TableRow>
                )
              ) : (
                pageRows.map((u) => (
                  <TableRow
                    key={u.id}
                    hover
                    sx={{ cursor: 'pointer' }}
                    onClick={() => openDetail(u)}
                  >
                    {columns.map((col, j) => (
                      <TableCell key={j} sx={{ textAlign: 'left' }}>
                        {col.render(u)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={total_count}
                  page={pageInfo.page}
                  rowsPerPage={pageInfo.rowsPerPage}
                  onPageChange={onPageChange}
                  onRowsPerPageChange={onRowsPerPageChange}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  slotProps={{
                    actions: {
                      backIconButtonProps: { color: 'secondary' },
                      nextIconButtonProps: { color: 'secondary' }
                    }
                  }}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )
    },
    {
      key: '2',
      label: 'Demo Teachers',
      children: (
        <TableContainer sx={{ backgroundColor: '#fff' }}>
          <Table stickyHeader>
            {/* same structure as above, but data = demoList */}
            <TableHead>
              <TableRow>
                {columns.map((col, i) => (
                  <TableCell
                    key={i}
                    sx={{ fontSize: 16, fontWeight: 600, textAlign: 'left' }}
                  >
                    {col.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {isEmpty(pageRows) ? (
                userloading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <Loading size={30} />
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      No results
                    </TableCell>
                  </TableRow>
                )
              ) : (
                pageRows
                  .map((u) => (
                    <TableRow
                      key={u.id}
                      hover
                      sx={{ cursor: 'pointer' }}
                      onClick={() => openDetail(u)}
                    >
                      {columns.map((col, j) => (
                        <TableCell key={j} sx={{ textAlign: 'left' }}>
                          {col.render(u)}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={total_count_demo}
                  page={demopageInfo.page}
                  rowsPerPage={demopageInfo.rowsPerPage}
                  onPageChange={onDemoPageChange}
                  onRowsPerPageChange={onDemoRowsPerPageChange}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  slotProps={{
                    actions: {
                      backIconButtonProps: { color: 'secondary' },
                      nextIconButtonProps: { color: 'secondary' }
                    }
                  }}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )
    }
  ];

  return (
    <>
      <SpinLoader dataloader={data_loading} />
      <MuiModal open={!!confirmUser} onClose={closeConfirm}>
        <ModalContent>
          Are you sure you want to{' '}
          {confirmUser?.active ? 'disable' : 'enable'}{' '}
          {get(confirmUser, 'firstName', '')}{' '}
          {get(confirmUser, 'lastName', '')}?
          <ModalActions>
            <Button onClick={closeConfirm} sx={{ mr: 1 }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleToggleActive}
              disabled={enableLoadingId === confirmUser?.id}
            >
              Yes
            </Button>
          </ModalActions>
        </ModalContent>
      </MuiModal>

      {/* detail modal */}
      <AntModal
        title={`${get(teacherData, 'firstName', '')} ${get(
          teacherData,
          'lastName',
          ''
        )}`}
        open={detailOpen}
        onCancel={closeDetail}
        footer={null}
        centered
        width="60%"
      >
        <Row justify="space-between">
          {isUserCoach ? null : <AntButton  onClick={() => onAddTeacher(true)}>
            Edit Profile
          </AntButton>}
          <ProfileContainer>
            <Login_as user={teacherData} />
            {get(teacherData, 'schoologyid', '') && (
              <AntButton
                disabled={!teacherData?.active || autologinLoader}
                onClick={() => handleOpenAutologin(get(teacherData, 'schoologyid', ''))}
                loading={autologinLoader}
              >
                Log in with Auto-Login
              </AntButton>
            )}
            <VocabAccessModal id={teacherData?.id} type="teacher" />
          </ProfileContainer>
        </Row>

        <Card type="inner" title="Detail View" style={{ marginTop: 16 }}>
          <Row gutter={16}>
            <Col span={12}>
              <p>
                <strong>First name:</strong>{' '}
                {get(teacherData, 'firstName', '')}
              </p>
              <p>
                <strong>User Name:</strong>{' '}
                {get(teacherData, 'username', '')}
              </p>
              <p>
                <strong>Created At:</strong> {get(teacherData, 'date', '')}
              </p>
            </Col>
            <Col span={12}>
              <p>
                <strong>Last name:</strong>{' '}
                {get(teacherData, 'lastName', '')}
              </p>
              <p>
                <strong>Password:</strong>{' '}
                <PasswordRevealInline userId={teacherData?.id} username={teacherData?.username} />
              </p>
              {getUserIntegrationDetail(teacherData)}

            </Col>
          </Row>
          <Divider />
          <Row gutter={16}>
            <Col span={12}>
              <p>
                <strong>School Name:</strong>{' '}
                <span
                  style={{
                    color: 'rgb(20, 100, 255)',
                    cursor: 'pointer'
                  }}
                  onClick={() => onTabsJump('see_schools', teacherData)}
                >
                  {get(teacherData, 'school_name', '')}
                </span>
              </p>
            </Col>
            <Col span={12}>
              <p>
                <strong>Classes:</strong>{' '}
                <span
                  style={{
                    color: 'rgb(20, 100, 255)',
                    cursor: 'pointer'
                  }}
                  onClick={() => onTabsJump('see_classes', teacherData)}
                >
                  {get(teacherData,"active_class_count")}
                </span>
              </p>
            </Col>
          </Row>
        </Card>
      </AntModal>

      {/* toolbar + tabs */}
      <Wrapper>
        <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
          {isUserCoach ? null : <AntButton
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => onAddTeacher(false)}
          >
            Add Teachers
          </AntButton>}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <Input
              placeholder="Search Teachers by name"
              value={searchText}
              onChange={onSearch}
              style={{ width: 250 }}
            />
            {searchLoader && (
              <BarsLoader>
                <span></span>
                <span></span>
                <span></span>
              </BarsLoader>
            )}
          </div>
        </Row>

        <SectionTitle>
          View <Highlight>Teacher</Highlight> Records.
        </SectionTitle>

        <Tabs
          activeKey={activeTab}
          onChange={(key) => {
            setActiveTab(key);
            setPageInfo((p) => ({ ...p, page: 0 }));
          }}
          items={tabs}
        />
      </Wrapper>
    </>
  );
}